{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "definitions": [
    {
      "type": "container",
      "title": "Belegdaten",
      "definitions": [
        {
          "type": "date",
          "title": "",
          "name": "belegdatum",
          "class": "color-light"
        },
        {
          "type": "entity",
          "title": "",
          "name": "konto",
          "endpoint": "",
          "format": "{{number}} - {{name}}",
          "class": "font-bold text-lg"
        },
        {
          "type": "string",
          "title": "Belegnummer: ",
          "name": "belegnummer"
        },
        {
          "type": "entity",
          "title": "Objekt: ",
          "name": "objekt",
          "endpoint": "",
          "format": "{{number}} - {{name}}"
        }
      ]
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "gesamt",
      "codeName": "currency",
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "net",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ]
    }
  ]
}
